class CyclingImages {
  constructor(element) {
    this.container = element;
    this.items = Array.from(this.container.querySelectorAll('.cycling-images__item'));
    
    this.currentPair = 0;
    this.totalPairs = Math.ceil(this.items.length / 2);
    this.isAnimating = false;
    this.autoPlay = this.container.dataset.autoCycle === 'true';
    this.interval = parseInt(this.container.dataset.cycleInterval) || 20000;
    this.autoPlayTimer = null;
    this.lastPair = -1; // Track the last shown pair to avoid repeats

    if (this.items.length > 0) {
      this.init();
    }
  }

  init() {
    this.showCurrentPair();
    
    if (this.autoPlay) {
      this.startAutoPlay();
    }
    
    // Pause auto-play when page is not visible
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.pauseAutoPlay();
      } else if (this.autoPlay) {
        this.startAutoPlay();
      }
    });
  }


  showCurrentPair() {
    if (this.isAnimating) return;
    
    this.isAnimating = true;
    
    // Hide all items
    this.items.forEach(item => {
      item.classList.remove('cycling-images__item--visible');
    });
    
    // Show current pair
    const startIndex = this.currentPair * 2;
    const endIndex = Math.min(startIndex + 2, this.items.length);
    
    for (let i = startIndex; i < endIndex; i++) {
      if (this.items[i]) {
        this.items[i].classList.add('cycling-images__item--visible');
      }
    }
    
    
    // Reset animation flag immediately since there's no transition
    this.isAnimating = false;
  }


  nextPair() {
    if (this.isAnimating) return;
    
    // If we have more than one pair, ensure we don't show the same pair consecutively
    if (this.totalPairs > 1) {
      let nextPair;
      do {
        nextPair = Math.floor(Math.random() * this.totalPairs);
      } while (nextPair === this.currentPair);
      
      this.lastPair = this.currentPair;
      this.currentPair = nextPair;
    } else {
      // If only one pair, just cycle normally
      this.currentPair = (this.currentPair + 1) % this.totalPairs;
    }
    
    this.showCurrentPair();
  }

  startAutoPlay() {
    if (!this.autoPlay || this.totalPairs <= 1) return;
    
    this.autoPlayTimer = setInterval(() => {
      this.nextPair();
    }, this.interval);
  }

  pauseAutoPlay() {
    if (this.autoPlayTimer) {
      clearInterval(this.autoPlayTimer);
      this.autoPlayTimer = null;
    }
  }


  destroy() {
    this.pauseAutoPlay();
    // Remove event listeners would go here if needed
  }
}

// Initialize cycling images when DOM is loaded
function initCyclingImages() {
  const cyclingImagesContainers = document.querySelectorAll('.cycling-images');
  cyclingImagesContainers.forEach(container => {
    new CyclingImages(container);
  });
}

// Initialize on DOM content loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCyclingImages);
} else {
  initCyclingImages();
}

// Re-initialize if content is dynamically loaded (for Shopify's AJAX cart, etc.)
document.addEventListener('shopify:section:load', initCyclingImages);